import { FavoriteSearch } from "search/favoriteSearch";
import { ref, Ref } from "vue";

// These ref are used between components, so they must be outside the function to persist the state
const favoriteSearches: Ref<FavoriteSearch[]> = ref([]);
const isFetchedFavoriteSearches = ref(false);

export function useFavoriteSearch() {
  function setFavoriteSearches(newFavoriteSearches: FavoriteSearch[]) {
    favoriteSearches.value = newFavoriteSearches;
  }

  function setIsFetchedFavoriteSearches(isFetched: boolean) {
    isFetchedFavoriteSearches.value = isFetched;
  }

  return { isFetchedFavoriteSearches, setIsFetchedFavoriteSearches, favoriteSearches, setFavoriteSearches };
}
